import { Pipe, PipeTransform } from '@angular/core';
import { Request } from '../../classes/request';

@Pipe({
  name: 'companyNameFilter',
  pure: false
})
export class CompanyNameFilterPipe implements PipeTransform {

  transform(requestList: Array<Request>, filterValue: string): any {
    if (!requestList || !filterValue) {
      return requestList;
    }
    const normalizedFilter = filterValue.toLowerCase();
    return requestList.filter(request =>
      (request.customer?.CompanyName || '').toLowerCase().indexOf(normalizedFilter) !== -1
    );
  }

}
